import { useEffect, useState, useCallback } from 'react';
import { ArrowUp } from 'lucide-react';

// Buffers posts pushed over WebSocket ("bourbon:new_post") and lets the user reveal them
export const useLivePosts = ({ userId, matches }) => {
  const [pending, setPending] = useState([]);

  useEffect(() => {
    const onNewPost = (e) => {
      const post = e.detail;
      if (!post || post.user_id === userId || !matches(post)) return;
      setPending((prev) => (prev.some((p) => p.post_id === post.post_id) ? prev : [post, ...prev]));
    };
    window.addEventListener('bourbon:new_post', onNewPost);
    return () => window.removeEventListener('bourbon:new_post', onNewPost);
  }, [userId, matches]);

  // Filters changed → pending posts may no longer match
  useEffect(() => { setPending([]); }, [matches]);

  const take = useCallback(() => {
    const items = pending;
    setPending([]);
    return items;
  }, [pending]);

  return { pending, take, clear: () => setPending([]) };
};

export const LivePostsBanner = ({ count, onShow }) => {
  if (!count) return null;
  return (
    <div className="sticky top-[72px] z-40 flex justify-center pointer-events-none" data-testid="live-posts-banner">
      <button
        type="button"
        onClick={onShow}
        className="pointer-events-auto inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-lg animate-in slide-in-from-top-2 hover:brightness-110 transition"
        data-testid="live-posts-show-btn"
      >
        <ArrowUp className="h-4 w-4" />
        {count === 1 ? '1 nouveau post' : `${count} nouveaux posts`} · Afficher
      </button>
    </div>
  );
};
